let shadowBoxes = document.querySelectorAll('.ct-block.shadow-box');

// intersection observer
let options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.8
};

let observer = new IntersectionObserver((entries,observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view');
    }
  });
}, options); 

shadowBoxes.forEach((shadowBox) => {
  observer.observe(shadowBox);
});